// @analyze-exports:disable
export const OVERLAY_CLOSE_ELEMENT_ATTR = 'data-overlay-close-element';

export const OVERLAY_CLOSE_ELEMENT_PROPS = {
    [OVERLAY_CLOSE_ELEMENT_ATTR]: 'true',
};
